<template>
  <div class="container">
    <div class="banner">
      <div class="content">
        <div class="caption">课程学习</div>
        <p>COURSE LEARNING</p>
      </div>
    </div>
    <div class="breadcrumb flex-fs">
      <div class="content">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>课程详情</el-breadcrumb-item>
          <el-breadcrumb-item>{{ data.courseTitle }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="courseDes content">
      <div class="top">
        <div class="img">
          <img :src="getFullImageUrl(data.coursePic)" alt="" />
        </div>
        <div class="info">
          <div class="title">{{ data.courseTitle }}</div>
          <div class="layout flex-fs">
            <div>课程类型</div>
            <div>{{ courseTypeText }}</div>
            <div>课程时长</div>
            <div>{{ data.courseTime && (data.courseTime/60 ).toFixed(0)}}分钟</div>
          </div>
          <div class="dec">
            <div class="caption">课程简介</div>
            <div class="text">
              {{ data.remark }}
            </div>
          </div>
        </div>
      </div>
      <!------>
      <div class="bottom mulu">
        <div class="caption">课程目录</div>
        <div class="mulu-list">
          <div class="courseInfo">
            <template v-for="item in handleTreeList">
              <div class="chapter">
                {{ item.infoTitle }}
              </div>
              <div class="chapter-content" v-if="item.children.length > 0">
                <div
                  class="sub"
                  v-for="sonItem in item.children"
                  @click="handelDialogVisible"
                >
                  {{ sonItem.infoTitle }}

                  <!-- <div class="mulu-right flex-fs">
                    <img src="../assets/image/vedio.png" alt="" />
                    <div class="time">
                      {{ secondsToTime(sonItem.infoTime) }}
                    </div>
                    <div class="progess">
                      <el-progress
                        class="pro"
                        :percentage="progess(sonItem.studyTime,sonItem.infoTime)"
                      ></el-progress>
                    </div>
                    <span class="status">{{
                      sonItem.infoType == 1 ? "未学习" : "已学习"
                    }}</span>
                  </div> -->
                </div>
              </div>
            </template>
          </div>
          <!-- <template v-for="item in handleTreeList">
            <div class="title">{{ item.infoTitle }}</div>
            <ul v-show="item.children.length > 0">
              <li
                class="mulu-item flex-sb"
                v-for="sonItem in item.children"
                @click="dialogVisible = true"
              >
                {{ sonItem.infoTitle }}
                <div class="mulu-right flex-fs">
                  <img src="../assets/image/vedio.png" alt="" />
                  <div class="time">{{ secondsToTime(sonItem.infoTime) }}</div>
                  <div class="progess">
                    <el-progress
                      :percentage="sonItem.studyTime ? sonItem.studyTime : 0"
                    ></el-progress>
                  </div>
                  <span class="status">{{
                    sonItem.infoType == 1 ? "未学习" : "已学习"
                  }}</span>
                </div>
              </li>
            </ul>
          </template> -->
        </div>
      </div>
    </div>
    <!------>
    <el-dialog
      class="buy-container"
      title=""
      :visible.sync="dialogVisible"
      :show-close="false"
      width="1315"
      height="900"
    >
      <div class="buy-container">
        <div class="buy-tips">
          <div class="caption">温馨提示:</div>
          <div>
            1.课程属于特殊商品，支付购买后不予退款，请认证核对专业信息，谨慎下单!

          </div>
          <div>
            2.首次注册请选择首个专业，默认选择全部课程共60学时。增项注册请再购买首个专业后再购买，需要选择3门必修+3门选修共30学时。
          </div>
        </div>
        <div class="buy-content">
          <div class="buy-menu">
            <div class="caption">请选择注册类型</div>
            <div class="tabs flex-fs">
              <div
                :class="{ current: item.dictValue == orderType }"
                v-for="item in orderTypeList"
                class="tab-item"
                @click="getOrderType(item.dictValue)"
              >
                {{ item.dictLabel }}
              </div>
            </div>
            <div class="caption">请选择专业目录</div>
            <div class="tabs flex-fs">
              <div
                :class="{ current: item.dictValue == courseMajor }"
                v-for="item in catalogueList"
                class="tab-item"
                @click="getCourseMajor(item.dictValue)"
              >
                {{ item.dictLabel }}
              </div>
              <div class="tab-item">机电工程</div>
            </div>
            <div class="tips">
              说明：首次注册默认为选择全部课程，增项注册时需要选择3门必修课程+3门选修课程。
            </div>
          </div>
          <!------>

          <div class="buy-bottom">
            <div class="caption flex-fs">
              <div>必修课程</div>
              <span>
                已选必修课程：{{
                  orderType == 2 ? bixuanIds.length : bixuan.length
                }}门</span
              >
              已选课程总时长：{{
                orderType == 2 ? 0 : changeMin(bixuanTime)
              }}分钟
            </div>
            <el-checkbox-group v-model="bixuanIds">
              <div class="course-list flex-fs">
                <div class="course-list-item" v-for="item in bixuan">
                  <el-checkbox
                    v-if="orderType != 1"
                    size="50"
                    class="checkbox"
                    :label="item.courseId"
                  ></el-checkbox>
                  <div class="item-img">
                    <img :src="getFullImageUrl(item.coursePic)" />
                  </div>
                  <div class="title">
                    {{ item.courseTitle }}
                  </div>
                  <div class="star-view">
                    <i class="el-icon-star-off"></i>

                    {{ item.collectNum }}

                    <span
                      ><i class="el-icon-view"></i> {{ item.courseClick }}</span
                    >
                  </div>
                </div>
              </div>
            </el-checkbox-group>
            <div class="caption flex-fs">
              <div>选修课程</div>
              <span>
                已选选修课程：{{
                  orderType == 2 ? kexuanIds.length : kexuan.length
                }}门</span
              >
              已选课程总时长：{{
                orderType == 2 ? 0 : changeMin(kexuanTime)
              }}分钟
            </div>
            <el-checkbox-group v-model="kexuanIds">
              <div class="course-list flex-fs">
                <div class="course-list-item" v-for="item in kexuan">
                  <el-checkbox
                    v-if="orderType != 1"
                    size="50"
                    class="checkbox"
                    :label="item.courseId"
                  ></el-checkbox>
                  <div class="item-img">
                    <img :src="getFullImageUrl(item.coursePic)" />
                  </div>
                  <div class="title">
                    {{ item.courseTitle }}
                  </div>
                  <div class="star-view">
                    <i class="el-icon-star-off"></i>

                    {{ item.collectNum }}
                    <span
                      ><i class="el-icon-view"></i> {{ item.courseClick }}</span
                    >
                  </div>
                </div>
              </div>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button :loading="loading" @click="requestCreateOrder" type="primary"
          >确认购买</el-button
        >
      </div>
    </el-dialog>

    <!------>
    <el-dialog
      class="qrcode-container"
      title=""
      :visible.sync="dialogCodeVisible"
      :show-close="false"
      width="960"
      height="800"
    >
      <div>
        <img :src="'data:image/jpeg;base64,' + qrcode" alt="" />
      </div>
      <div class="tips">
        请使用手机微信扫码支付，支付成功后点击支付完成按钮查
        <p>看购买状态，如状态未更新请稍后再次刷新页面</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCodeVisible = false">取消</el-button>
        <el-button @click="paymentCompletion" :loading="loading" type="primary"
          >支付完成</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { handleTree } from "@/utils/handleTree";
import { getCourseDetails, createOrder, getType, getCourseList } from "@/api";
export default {
  name: "CourseDes",
  data() {
    return {
      qrcode: "",
      dialogCodeVisible: false,
      loading: false,
      dialogVisible: false,
      bixuan: [],
      kexuan: [],
      bixuanTime: 0,
      kexuanTime: 0,
      bixuanIds: [],
      kexuanIds: [],
      data: {
        courseInfoList: [],
      },
      // courseTypeList: this.$store.state.ej_course_type,
      courseTypeText: "",
      catalogueList: [],
      orderTypeList: [],
      courseMajor: "",
      orderType: "1",
      handleTreeList: [],
    };
  },

  mounted() {
    this.requestGetCourseDetails(this.$route.query.courseId);
    this.catalogueList = JSON.parse(localStorage.getItem("catalogueList"));

    this.courseMajor = this.catalogueList[0].dictValue;

    this.init();
  },
  methods: {
    init() {
      getType("ej_order_type").then((res) => {
        this.orderTypeList = res.data;
      });
    },
    paymentCompletion() {
      this.dialogCodeVisible = false;
      this.dialogVisible = false;
      this.$router.push({
        path: "/usercenter",
        query: { showTemponent: "TrainingPayment" },
      });
    },
    handelDialogVisible() {
      let userInfo = JSON.parse(localStorage.getItem('userInfo'))

      if (userInfo.userAuth != 2) {
        this.$confirm("请完成用户认证后再操作!", "提示", {
          confirmButtonText: "去认证",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push({
              path: "/usercenter",
              query: { showTemponent: "BasicInformation" },
            });
          })
          .catch(() => {});
          return
      }

      this.getCourseData();
      this.dialogVisible = true;
    },

    getOrderType(val) {
      this.orderType = val;
    },
    getCourseMajor(val) {
      this.courseMajor = val;
      this.getCourseData();
    },
    requestCreateOrder() {
      let orderDetailList = [];
      this.kexuanIds.forEach((res) => {
        orderDetailList.push({ courseId: res });
      });
      this.bixuanIds.forEach((res) => {
        orderDetailList.push({ courseId: res });
      });
      //首个专业 全传

      if (
        this.orderType == 2 &&
        this.kexuanIds.length < 3 &&
        this.bixuanIds.length < 3
      ) {
        return this.$notify({
          title: "提示",
          message: "请选择3门必修课程+3门选修课程",
          type: "warning",
        });
      }
      this.loading = true;
      createOrder({
        orderType: this.orderType,
        courseMajor: this.courseMajor,
        orderDetailList,
      })
        .then((res) => {
          if (res.code == 200) {
            this.qrcode = res.data.qrCode;
            this.dialogCodeVisible = true;
          }
          console.log("🚀 ~ requestCreateOrder ~ res:", res);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCourseData() {
      getCourseList({ courseMajor: this.courseMajor }).then((res) => {
        let bixuan = [];
        let kexuan = [];
        let bixuanTime = 0;
        let kexuanTime = 0;

        if (res.code == 200) {
          res.rows.forEach((res) => {
            if (res.courseType == 1) {
              bixuanTime += res.courseTime;
              bixuan.push(res);
            } else {
              kexuanTime += res.courseTime;
              kexuan.push(res);
            }
          });
          this.bixuan = bixuan;
          this.kexuan = kexuan;
          this.bixuanTime = bixuanTime;
          this.kexuanTime = kexuanTime;
        }
      });
    },
    requestGetCourseDetails(courseId) {
      getCourseDetails(courseId).then((res) => {
        if (res) {
          this.data = res.data;
          this.handleTreeList = handleTree(
            res.data.courseInfoList,
            "infoId",
            "parentId"
          );
          console.log("🚀 ~ requestGetCourseDetails ~ this.handleTreeList:", this.handleTreeList)

          // 根据dictValue查找对应的dictLabel
          let courseTypeList =
            localStorage.getItem("courseTypeList") &&
            JSON.parse(localStorage.getItem("courseTypeList"));
          const found = courseTypeList.find(
            (item) => item.dictValue === res.data.courseType
          );
          this.courseTypeText = found.dictLabel;
        }
      });
    },
    progess(studyTime, courseTime, symbol = false) {
      if (studyTime == 0) {
        return 0;
      }
      let key = `${((studyTime / courseTime) * 100).toFixed(0)}${
        symbol ? "%" : ""
      }`;
      return key;
    },
    secondsToTime(seconds) {
      const hours = Math.floor(seconds / 3600); // 计算小时数
      const minutes = Math.floor((seconds % 3600) / 60); // 计算分钟数
      const remainingSeconds = seconds % 60; // 计算剩余的秒数
      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
    },
    changeMin(min) {
      return Math.ceil(min / 60);
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background: #f3f4f8;
  padding-bottom: 55px;
  .banner {
    min-width: 1600px;
    color: #fff;
    height: 510px;
    background: url("../assets/image/kec.png");
    background-size: 100% 100%;
    padding-top: 170px;
    .content {
      padding-left: 150px;
    }
    .caption {
      font-size: 46px;
      font-weight: bold;
    }
    p {
      font-size: 12px;
      padding-: 5px;
    }
  }
  .breadcrumb {
    height: 39px;
    background: #e3eefb;
  }
  .courseDes {
    padding-bottom: 110px;
    background-color: #fff;

    .top {
      padding-top: 72px;
      padding-left: 61px;
      display: flex;
      align-items: start;
      justify-content: center;
      padding-right: 57px;
      .img {
        width: 535px;
        height: 354px;
        overflow: hidden;
        margin-right: 55px;

        img {
          width: 100%;
        }
      }
      .info {
        .title {
          font-size: 28px;
          color: #000000;
          margin-bottom: 42px;
        }
        .layout {
          margin-bottom: 42px;
          div {
            width: 223px;
            text-align: center;
            height: 39px;
            line-height: 39px;
            font-size: 16px;
            color: #000;
            background: #f7f7f7;
            border: 1px solid #eeeeee;
            &:nth-child(2n + 1) {
              background: #fff;
            }
          }
        }
      }
      .dec {
        .caption {
          font-weight: bold;
          font-size: 18px;
          color: #000000;
          margin-bottom: 26px;
          padding-left: 50px;
          margin-bottom: 25px;
        }
        .text {
          font-size: 14px;
          color: #939393;
        }
      }
    }
    ////
    .mulu {
      .caption {
        font-weight: bold;
        font-size: 18px;
        color: #000000;
        padding-left: 58px;
        padding-bottom: 20px;
        padding-top: 58px;
      }
      .mulu-list {
        font-size: 16px;
        color: #333;

        .mulu-item {
          height: 61px;
          padding-left: 50px;
          border: 1px dashed #eeeeee;
          cursor: pointer;
          &:nth-child(1) {
            border: 0;
          }
          .time {
            color: #999;
            padding: 0 10px;
          }
          .progess {
            width: 180px;
          }
          .status {
            padding-right: 30px;
            padding-left: 20px;
          }
          img {
            width: 20px;
          }
        }
      }
    }

    /////
    .courseInfo {
      padding-left: 36px;
      padding-right: 22px;
      min-height: 500px;



      .des {
        padding-top: 10px;
        line-height: 25px;
        text-indent: 2ch;
      }
      .chapter {
        font-size: 16px;
        margin-bottom: 22px;
        margin-top: 18px;
        cursor: pointer;
        &.current {
          color: #1265cc;
        }
      }
      .chapter-content {
        font-size: 14px;
        padding-left: 65px;
        position: relative;
        &::before {
          content: "";
          border-left: 1px dashed #ddd;
          top: 8px;
          left: 54px;
          bottom: 8px;
          position: absolute;
        }
        & > div {
          cursor: pointer;
          position: relative;
          margin-bottom: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          &.sub::after {
            content: "";
            width: 8px;
            height: 8px;
            border: 1px solid #666;
            border-radius: 10px;
            position: absolute;
            left: -16px;
            top: 50%;
            margin-top: -4px;
          }
        }
        .current {
          color: #1265cc;
          span {
          }
        }
      }
      .mulu-right {
        height: 61px;
        padding-left: 50px;
        border: 1px dashed #eeeeee;
        cursor: pointer;
        &:nth-child(1) {
          border: 0;
        }
        .time {
          color: #999;
          padding: 0 10px;
        }
        .progess {
          width: 180px;
        }
        .status {
          padding-right: 30px;
          padding-left: 20px;
        }
        img {
          width: 20px;
        }
      }
    }
  }
}
.buy-container {
  overflow-y: auto;
  /deep/.el-dialog {
    width: 1315px;
    height: 980px;
    top: 50%;
    margin-top: -490px !important;
  }
  /deep/.el-dialog__header,
  /deep/.el-dialog__body {
    padding: 0;
  }
  /deep/.el-checkbox__label {
    display: none;
  }
  .dialog-footer {
    text-align: center;
    padding-top: 40px;
  }
  .buy-tips {
    color: #fff;
    background: url(../assets/image/pay.png);
    background-size: 100% 100%;
    padding-top: 30px;
    padding-left: 64px;
    height: 143px;
    font-size: 14px;
    font-weight: bold;
    div {
      margin-bottom: 10px;
    }
    .caption {
      font-size: 20px;
    }
    span {
      color: #ffba42;
    }
  }
  .buy-content {
    padding: 36px 65px 0;
    height: 700px;
    overflow-y: auto;
    .buy-menu {
      .caption {
        margin-bottom: 15px;
        font-weight: bold;
        font-size: 18px;
        color: #000000;
      }
      .tabs {
        margin-bottom: 21px;
        .tab-item {
          min-width: 91px;
          height: 38px;
          font-size: 13px;
          background: #f7f7f7;
          color: #333;
          text-align: center;
          line-height: 38px;
          border-radius: 5px;
          margin-right: 14px;
          cursor: pointer;
          &.current {
            background: #1890ff;
            color: #fff;
          }
        }
      }
      .tips {
        font-size: 14px;
        color: #666666;
        margin-bottom: 24px;
        margin-top: -5px;
      }
    }
    /////
    .buy-bottom {
      font-size: 14px;
      color: #666;
      .caption {
        line-height: 50px;
        div {
          font-size: 18px;
          color: #000000;
          font-weight: bold;
        }
        span {
          padding-left: 22px;
          padding-right: 60px;
        }
      }
      .course-list {
        flex-wrap: wrap;
        &-item {
          position: relative;
          border: 1px solid #eeeeee;
          position: relative;
          width: 220px;
          height: 200px;
          background: #fff;
          margin-bottom: 20px;
          margin-left: 15px;
          cursor: pointer;
          &:nth-child(5n + 1) {
            margin-left: 0;
          }
          .checkbox {
            position: absolute;
            top: 10px;
            right: 10px;
            /deep/.el-checkbox__inner {
              width: 20px;
              height: 20px;
              border-radius: 20px;
            }
            /deep/.el-checkbox__input.is-checked .el-checkbox__inner::after {
              top: 4px;
              left: 7px;
            }
          }
          .item-img {
            overflow: hidden;
            height: 140px;
            background: #eee;
            background-size: cover;
            img {
              width: 100%;
              height: 140px;
            }
          }
          .title {
            padding: 10px 15px 0;
            font-size: 11px;
            color: #000;
          }
          .star-view {
            color: #939393;
            font-size: 14px;
            position: absolute;
            bottom: 12px;
            right: 14px;
            i {
              font-size: 12px;
            }
            span {
              padding-left: 22px;
            }
          }
        }
      }
    }
  }
}
/////
.qrcode-container {
  text-align: center;
  .tips {
    color: #ff2442;
    font-size: 18px;
    line-height: 30px;
  }
  .dialog-footer {
    text-align: center;
  }
}
</style>
